














































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    deleteUser,
    getCompanies,
    getPrograms,
    deleteProgram,
    deleteLot,
    patchLotOptionEndAt,
    getLots,
    importLotCSV,
    patchLot,
    patchUpdateProgramStock,
    getProgram,
} from '@/api/api';
import {checkDocuments, infosMissing} from '@/data/programChecker';
import MetaDatatable from '../models/MetaDatatable';
import User from '../models/User';
import { lotStatus } from '../data/lot';
import AuthModule from '../store/AuthModule';
import get from 'lodash/get';
import { formatLotType, formatLotStatus } from '@/data/lot';
import Program from '../models/Program';
import Lot from '../models/Lot';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import Datatable from '@/components/Datatable.vue';
import ButtonLoading from '@/components/ButtonLoading.vue';
import ImportCsv from '@/components/ImportCsv.vue';
import ImportPlans from '@/components/ImportPlans.vue';
import { BACKEND_URL } from '../helpers/constants';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import OptionModel from '@/models/OptionModel';




@Component({
    filters: {
        formatLotType,
        formatLotStatus,
        formatProfitability: (lot: any) => {
          if (!isNaN(lot.rent_limit_pinel)){
            let rent = ((lot.rent_limit_pinel * 12) / lot.price) * 100 ;
            return new Intl.NumberFormat('fr-FR', {
              maximumFractionDigits: 1,
            }).format(rent) + "%";
          }

          if (isNaN(lot.profitability)) {
            return '';
          }

          return new Intl.NumberFormat('fr-FR', {
            maximumFractionDigits: 1,
          }).format(lot.profitability) + "%";
        },

    },
    components: {
        Datatable,
        ButtonLoading,
        ImportCsv,
        ImportPlans
    },
})
export default class Lots extends Vue {
    lotStatus = lotStatus;
    moment = moment;
    status: string = '';
    popupLots: boolean = false;
    popupPlans: boolean = false;
    error: string | null = null;

    documentsMissing: any = [];
    programInfosMissing: any = [];
    option_end_at_display: any = {};
    updatePopup: boolean = false;

    loading: boolean = false;
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Bâtiment',
            dataIndex: 'building',
            sorter: true,
        },
        {
            title: 'Nom',
            dataIndex: 'name',
            scopedSlots: {
                customRender: 'name',
            },
            sorter: true,
        },
        {
            title: 'Statut',
            dataIndex: 'status',
            scopedSlots: {
                customRender: 'status',
            },
            sorter: true,
        },
        {
            title: 'Fin d\'option',
            dataIndex: 'option_end_at',
            scopedSlots: {
                customRender: 'option_end_at',
            },
            sorter: false,
        },
        {
            title: 'Rentabilité',
            dataIndex: 'profitability',
            scopedSlots: {
                customRender: 'profitability',
            },
            sorter: true,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            scopedSlots: {
                customRender: 'type',
            },
            sorter: true,
        },
        {
            title: 'Type 2',
            dataIndex: 'type2',
            sorter: true,
        },
        {
            title: 'Niveau',
            dataIndex: 'floor',
            sorter: true,
        },
        {
            title: 'Prix TTC TVA 20%',
            dataIndex: 'price',
            scopedSlots: {
                customRender: 'price',
            },
            sorter: true,
        },
        {
          title: 'SDP',
          dataIndex: 'surfacedd_no_carrez',
          scopedSlots: {
            customRender: 'surfacedd_no_carrez',
          },
          sorter: true
        },
        {
            title: 'Plan',
            dataIndex: 'plan',
            scopedSlots: {
                customRender: 'plan',
            },
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    data: any[] = [];
    sizes = [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
    ];
    deleteText = {
        confirm: {
            title: `Suppression du lot`,
            content: `Voulez-vous vraiment supprimer le lot ?`,
        },
        notify: {
            title: 'Lot supprimé',
            content: `Le lot a bien été supprimé`,
        },
    };
    locale = {
        filterReset: 'Réinitialiser',
    };
    private tax_system: any;

    async patchLot(lot: Lot) {
        const $vs = (this as any).$vs;
        $vs.loading()
        if(lot.id) {
            let id = lot.id;
            delete lot.program;
            delete lot.plan;
            delete lot.created_at;
            //@ts-ignore
            delete lot.images;
            delete lot.id;
            delete lot.option_start_at;
            delete lot.option_end_at;
            await patchLot(id, lot).catch(
                (errors: { response: { data: { message: string | null; }; }; }) => {
                    this.error = errors.response.data.message;
                }
            );
            if (this.error) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: this.error,
                });
                return;
            }
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Lot Modifié`,
            });
        }
        $vs.loading.close()
    }

    async editStatus(lot: Lot) {
        console.log(lot.program);
        const $vs = (this as any).$vs;
        if(lot.id && lot) {
            let id = lot.id;
            delete lot.program;
            delete lot.plan;
            delete lot.created_at;
            //@ts-ignore
            delete lot.images;
            delete lot.id;
            delete lot.option_start_at;
            delete lot.option_end_at;
            await patchLot(id, lot).catch(
                (errors: { response: { data: { message: string | null; }; }; }) => {
                    this.error = errors.response.data.message;
                }
            );
            if (this.error) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: this.error,
                });
                return;
            }
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Statut Modifié`,
            });
        }
    }

    displayOptionEndAt(lot : Lot){
        let id = lot.id?lot.id.toFixed():0;
        this.option_end_at_display[id] = true
        this.refresh()
    }

    async editEndAt(date: moment.Moment, lot: Lot) {
        const $vs = (this as any).$vs;
        const DATE_TIME_PHP = 'YYYY-MM-DDTHH:mm:ssZZ';
        let option_end_at = date.format(DATE_TIME_PHP);

        await patchLotOptionEndAt(lot.id, option_end_at).catch(
            (errors: { response: { data: { message: string | null; }; }; }) => {
                this.error = errors.response.data.message;
            }
        );
        if (this.error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: this.error,
            });
            return;
        }
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Modification',
            text: `Date de fin d'option Modifiée`,
        });
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Lot | null;
    }) {
        const action = ev.action;
        const lot: Lot | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (lot !== null) {
                    this.$router.push({
                        name: 'editLot',
                        params: {
                            programID: this.$route.params.programID,
                            lotID: `${lot.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (lot && lot.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteLot(lot.id);
                }
                break;
        }
    }

    handleTableChange(
        pagination: PaginationDatatable,
        filters: any,
        sorter: SorterDatatable,
    ) {
        this.meta = {
            ...this.meta,
            page: pagination.current || 1,
            orderBy: sorter.field || null,
            orderWay: sorter.order === 'ascend' ? 'ASC' : 'DESC',
        };
    }

    async fetch(meta: MetaDatatable) {
        const { data } = await getLots(+this.$route.params.programID, {
            ...meta,
            page: meta.page - 1,
        });
        this.tax_system = this.getTaxSystems(data.data);
        this.addColumns(data.data);
        return data;
    }

    deleteDialog(lot: Lot) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(lot),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    refresh() {
        const $datatable = this.$refs.datatable as Datatable;
        $datatable.refresh();
    }

    async acceptDeleteAlert(lot: Lot) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: lot });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du lot`,
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    async updateProgram(record: any) {
        const {data} = await getProgram(+this.$route.params.programID);
        const documents = data.documents;
        this.documentsMissing = checkDocuments(documents);
        this.programInfosMissing = (infosMissing(data));
        if(this.documentsMissing.length > 0 || this.programInfosMissing.length > 0) {
            return this.updatePopup = true
        }
        return this.updateStocks();
    }

    updateStocks() {
        const $vs = (this as any).$vs;
        patchUpdateProgramStock(+this.$route.params.programID)
            .then(() => {
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Mise à jour du stock',
                    text: 'Mise à jour réussie',
                });
            })
            .catch(() => {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Mise à jour du stock',
                    text: 'Mise à jour échouée',
                });
            });
        return this.updatePopup = false;
    }

    get BACKEND_URL() {
        return BACKEND_URL;
    }

    private addColumns(lots: Lot[]) {
    if(this.tax_system) {
        this.columns = [
            {
                title: 'Bâtiment',
                dataIndex: 'building',
                sorter: true,
            },
            {
                title: 'Nom',
                dataIndex: 'name',
                scopedSlots: {
                    customRender: 'name',
                },
                sorter: true,
            },
            {
                title: 'Statut',
                dataIndex: 'status',
                scopedSlots: {
                    customRender: 'status',
                },
                sorter: true,
            },
            {
                title: 'Fin d\'option',
                dataIndex: 'option_end_at',
                scopedSlots: {
                    customRender: 'option_end_at',
                },
                sorter: true,
            },
            {
                title: 'Rentabilité',
                dataIndex: 'profitability',
                scopedSlots: {
                    customRender: 'profitability',
                },
                sorter: true,
            },
            {
                title: 'Type',
                dataIndex: 'type',
                scopedSlots: {
                    customRender: 'type',
                },
                sorter: true,
            },
            {
                title: 'Type 2',
                dataIndex: 'type2',
                sorter: true,
            },
            {
                title: 'Niveau',
                dataIndex: 'floor',
                sorter: true,
            },
            {
                title: 'Prix TTC TVA 20%',
                dataIndex: 'price',
                scopedSlots: {
                    customRender: 'price',
                },
                sorter: true,
            },
            {
              title: 'SDP',
              dataIndex: 'surface_carrez',
              scopedSlots: {
                customRender: 'surface_no_carrez',
              },
              sorter: true
            },
            {
              title: 'Expo.',
              dataIndex: 'exposure',
              scopedSlots: {
                customRender: 'exposure',
              },
              sorter: true
            },
            {
              title: 'm² Terrasse loggia',
              dataIndex: 'surface_terrace',
              scopedSlots: {
                customRender: 'surface_terrace',
              },
              sorter: true
            },
            {
              title: 'm² Terrasse varangue',
              dataIndex: 'surface_terrace_varangue',
              scopedSlots: {
                customRender: 'surface_terrace_varangue',
              },
              sorter: true
            },
            {
              title: 'm² jardin',
              dataIndex: 'surface_copro_garden',
              scopedSlots: {
                customRender: 'surface_copro_garden',
              },
              sorter: true
            },
            {
              title: 'Annexe 1',
              dataIndex: 'name_parking1',
              scopedSlots: {
                customRender: 'nameParking1',
              },
              sorter: false
            },
            {
              title: 'Cat Annexe 1',
              dataIndex: 'cat_parking1',
              scopedSlots: {
                customRender: 'catParking1',
              },
              sorter: false
            },
            {
              title: 'Annexe 2',
              dataIndex: 'name_parking2',
              scopedSlots: {
                customRender: 'nameParking2',
              },
              sorter: false
            },
            {
              title: 'Cat Annexe 2',
              dataIndex: 'cat_parking2',
              scopedSlots: {
                customRender: 'catParking2',
              },
              sorter: false
            },
            {
              title: 'Annexe 3',
              dataIndex: 'name_parking3',
              scopedSlots: {
                customRender: 'nameParking3',
              },
              sorter: false
            },
            {
              title: 'Cat Annexe 3',
              dataIndex: 'cat_parking3',
              scopedSlots: {
                customRender: 'catParking3',
              },
              sorter: false
            },
          {
            title: 'Plan',
            dataIndex: 'plan',
            scopedSlots: {
              customRender: 'plan',
            }
          },
          {
              title: 'Actions',
              dataIndex: 'action',
              scopedSlots: {
                  customRender: 'actions',
              },
              fixed: 'right',
          },
        ];
        function indexDe(columns: any, dataIndex: string) {
            for (let i = 0; i < columns.length; i++) {

                // console.log(dataIndex)
                // console.log(columns[i].dataIndex)
                // console.log(i)
                if (columns[i].dataIndex === dataIndex) {
                    return i;
                }

                }
                return -1;
            }

            function hasReducedPrice(lots: Lot[]) {
                for (let i = 0; i < lots.length; i++) {
                    if (lots[i].price_vat_reduce_or_controlled > 0) {
                        return true;
                    }
                }
                return false;
            }

            function hasBrsPrice(lots: Lot[]) {
                for (let i = 0; i < lots.length; i++) {
                    if (lots[i].price_reduced_brs > 0) {
                        return true;
                    }
                }
                return false;
            }

            function hasLliPrice(lots: Lot[]) {
                for (let i = 0; i < lots.length; i++) {
                    if (lots[i].price_reduced_lli > 0) {
                        return true;
                    }
                }
                return false;
            }

            function hasNueProPrice(lots: Lot[]) {
                for (let i = 0; i < lots.length; i++) {
                    if (lots[i].prix_nue_propriete  > 0) {
                        return true;
                    }
                }
                return false;
            }

            /*
                Prix BRS
                */
                if (this.tax_system.includes(9) || hasBrsPrice(lots)) {
                    const indexPrix = indexDe(this.columns, 'price');
                    this.columns.splice(indexPrix + 1, 0,
                        {
                            title: 'Prix BRS (TVA 5.5%)',
                            dataIndex: 'price_reduced_brs',
                            scopedSlots: {
                                customRender: 'price_reduced_brs',
                            },
                            sorter: true,
                        },
                    );
                }

                                /*
                Prix LLI
                */
                if (this.tax_system.includes(10) || hasLliPrice(lots)) {
                    const indexPrix = indexDe(this.columns, 'price');
                    this.columns.splice(indexPrix + 1, 0,
                        {
                            title: 'Prix LLI (Tva 10%)',
                            dataIndex: 'price_reduced_lli',
                            scopedSlots: {
                                customRender: 'price_reduced_lli',
                            },
                            sorter: true,
                        },
                    );
                }


                                                    /*
                Prix Nue-Pro
                */
                if (this.tax_system.includes(4) || hasNueProPrice(lots)) {
                    const indexPrix = indexDe(this.columns, 'price');
                    this.columns.splice(indexPrix + 1, 0,
                        {
                            title: 'Prix Nue-Proprieté',
                            dataIndex: 'prix_nue_propriete',
                            scopedSlots: {
                                customRender: 'prix_nue_propriete',
                            },
                            sorter: true,
                        },
                    );
                }


            /*
            Prix RP TVA reduite et Prix Maitrisé
             */
            if (this.tax_system.includes(7) || hasReducedPrice(lots)) {
                const indexPrix = indexDe(this.columns, 'price');
                this.columns.splice(indexPrix + 1, 0,
                    {
                        title: 'Prix TVA réduite/Prix maitrisé',
                        dataIndex: 'price_vat_reduce_or_controlled',
                        scopedSlots: {
                            customRender: 'price_vat_reduce_or_controlled',
                        },
                        sorter: true,
                    },
                );
            }
            /*
            Pinels
             */
            if (this.tax_system.includes(1) || this.tax_system.includes(2)) {
                const indexPrix = indexDe(this.columns, 'price');
                this.columns.splice(indexPrix + 1, 0,
                    {
                        title: 'Loyer marché recommandé Pk inclus',
                        dataIndex: 'recommended_market_rent_pk_included',
                        scopedSlots: {
                            customRender: 'recommended_market_rent_pk_included',
                        },
                        sorter: true,
                    },
                    {
                        title: 'Loyer marché mensuel maxi',
                        dataIndex: 'maximum_monthly_market_rent',
                        scopedSlots: {
                            customRender: 'maximum_monthly_market_rent',
                        },
                        sorter: true,
                    },
                );
            }
            /*
            LMNP
             */
            if (this.tax_system.includes(3)) {
                const indexPrix = indexDe(this.columns, 'price');
                this.columns.splice(indexPrix + 1, 0,
                    {
                        title: 'Loyer Garanti TTC',
                        dataIndex: 'garantee_rent',
                        scopedSlots: {
                            customRender: 'garantee_rent',
                        },
                        sorter: true,
                    },
                    {
                        title: 'LMNP/LMP Prix total HT',
                        dataIndex: 'location_amount_property',
                        scopedSlots: {
                            customRender: 'location_amount_property',
                        },
                        sorter: true,
                    },
                    {
                        title: 'LMNP/LMP dont montant mobilier HT',
                        dataIndex: 'location_amount_furniture',
                        scopedSlots: {
                            customRender: 'location_amount_furniture',
                        },
                        sorter: true,
                    },
                    {
                        title: 'LMNP/LMP montant Tva Récup.',
                        dataIndex: 'location_amount_vat_back',
                        scopedSlots: {
                            customRender: 'location_amount_vat_back',
                        },
                        sorter: true,
                    },
                );
            }

            /*
            Demembrement
             */
            // if (this.tax_system.includes(4)) {
            //     this.columns.splice(indexPrix + 1, 0,
            //         {
            //             title: 'Montant Nu propriété',
            //             dataIndex: 'full_ownership_amount',
            //             scopedSlots: {
            //                 customRender: 'full_ownership_amount',
            //             },
            //             sorter: true,
            //         },
            //     );
            // }
            /*
            Travaux
             */
            if (this.tax_system.includes(2)) {
                const indexPlan = indexDe(this.columns, 'plan');
                this.columns.splice(indexPlan, 0,
                    {
                        title: 'Montant du foncier hors travaux',
                        dataIndex: 'amount_property',
                        scopedSlots: {
                            customRender: 'amount_property',
                        },
                        sorter: true,
                    },
                    {
                        title: 'Montant travaux hors foncier',
                        dataIndex: 'amount_work',
                        scopedSlots: {
                            customRender: 'amount_work',
                        },
                        sorter: true,
                    },
                    {
                        title: 'Montant travaux partie commune',
                        dataIndex: 'amount_work_no_defisc',
                        scopedSlots: {
                            customRender: 'amount_work_no_defisc',
                        },
                        sorter: true,
                    },
                );
            }
            /*
            Plafond loyer

             */
            if (this.tax_system.includes(5) || this.tax_system.includes(8) || this.tax_system.includes(1)) {
                const indexPlan = indexDe(this.columns, 'plan');
                this.columns.splice(indexPlan, 0,
                    {
                        title: 'Plafond Loyer',
                        dataIndex: 'rent_limit_pinel',
                    },
                );
            }
            /*
            Prix parking
             */
            if (this.tax_system.includes(1) || this.tax_system.includes(2) || this.tax_system.includes(7) || hasReducedPrice(lots)) {
                const indexPlan = indexDe(this.columns, 'plan');
                this.columns.splice(indexPlan, 0,
                    {
                        title: 'Prix TTC tous les Pk TVA 20%',
                        dataIndex: 'price_parking',
                    },
                );
                // this.columns.splice(indexPlan, 0,
                //     {
                //         title: 'Prix Parkings TVA Reduite/Prix maitrisé',
                //         dataIndex: 'price_parking_reduced_vat',
                //     },
                // );
            }
        }
    }

    private getTaxSystems(lots: Lot[]) {

        if (lots[0] && lots[0].program) {
            let program = lots[0].program;
            if (
                !program ||
                !program.tax_system ||
                program.tax_system.length < 1
            ) {
                return;
            }

            let arrayReturn = [];
            let arraytaxSystem = program.tax_system;
            //const firstTaxSystem = program.tax_system[0];
            for (let i = 0; i < arraytaxSystem.length; i++) {
                if (
                    [
                        'Pinel / Rés. principale',
                        'PLS',
                        'PINEL Sénior',
                        'PINEL Ancien',
                        'PINEL Outre Mer',
                    ].includes(arraytaxSystem[i])
                ) {
                    console.log('tax_system_category: 1');
                    arrayReturn.push(1);
                } else if (
                    [
                        'Denormandie',
                        'Malraux',
                        'Monuments historiques',
                        'Déficits fonciers',
                        'Loi COSSE Ancien-Louer Abordable',
                    ].includes(arraytaxSystem[i])
                ) {
                    console.log('tax_system_category: 2');
                    arrayReturn.push(2);
                } else if (
                    [
                        'LMNP VEFA Divers',
                        'LMNP Étudiant',
                        'LMNP Senior',
                        'LMNP Tourisme',
                        'LMNP EHPAD',
                        'LMNP Coliving',
                        'LMNP Colocation',
                        'LMNP CRT',
                        'CIIC Corse',
                        'Revente LMNP',
                        'Revente LMNP Tourisme',
                        'Revente LMNP Étudiant',
                        'Revente LMNP Sénior',
                        'Revente LMNP Rés',
                        'Revente LMNP EHPAD'

                    ].includes(arraytaxSystem[i])
                ) {
                    console.log('tax_system_category: 3');
                    arrayReturn.push(3);
                } else if (arraytaxSystem[i] === 'Démembrement de propriété') {
                    console.log('tax_system_category: 4');
                    arrayReturn.push(4);
                } else if (arraytaxSystem[i] === 'Projet construction') {
                    console.log('tax_system_category: 5');
                    arrayReturn.push(5);
                } else if (arraytaxSystem[i] === 'Revente fin défiscalisation') {
                    console.log('tax_system_category: 6');
                    arrayReturn.push(6);
                } else if (arraytaxSystem[i] === 'RP Tva Réduite/Prix Maitrisé') {
                    console.log('tax_system_category: 7');
                    arrayReturn.push(7);
                } else if (arraytaxSystem[i] === 'Denormandie') {
                    console.log('tax_system_category: 8');
                    arrayReturn.push(8);
                }
                else if (arraytaxSystem[i] === 'BRS') {
                    console.log('tax_system_category: 9');
                    arrayReturn.push(9);
                }
                else if (arraytaxSystem[i] === 'LLI') {
                    console.log('tax_system_category: 10');
                    arrayReturn.push(9);
                }
            }
            return arrayReturn;
            //return null;
        }

    }
}
